<template>
  <span>{{ price }}</span>
</template>

<script>
import { formatPrice } from '../src/Helpers.js';

export default {
  props: {
    priceGbp: {
      type: Number | null,
      required: true,
    },
    priceUsd: {
      type: Number | null,
      required: true,
    },
    forceCurrency: {
      type: String,
      default: null,
    }
  },

  computed: {
    currency() {
      if (this.forceCurrency) {
        return this.forceCurrency;
      }

      return this.$store.state.currency.currentCurrency;
    },

    rawPrice() {
      return this.currency === 'USD' ? this.priceUsd : this.priceGbp;
    },

    currencySymbol() {
      return this.currency === 'USD' ? '$' : '£';
    },

    price() {
      if (!this.rawPrice) {
        return '-';
      }

      return `${this.currencySymbol}${this.readablePrice(this.rawPrice)}`;
    },
  },

  methods: {
    readablePrice(price) {
      return formatPrice(price);
    },
  },
};
</script>
